export function determineIfDateIs24HoursOld(date: Date | undefined) {
    if (!date) {
        return false
    }

    // get the date and time of 24 hours ago
    const yesterday = new Date(new Date().getTime() - 24 * 60 * 60 * 1000)
    return date <= yesterday
}
